export const GET_INQUIRY_LOGS: string = 'GET_INQUIRY_LOGS'
export const GET_INQUIRY_LOGS_SUCCESS: string = 'GET_INQUIRY_LOGS_SUCCESS'
export const GET_INQUIRY_LOGS_FAILURE: string = 'GET_INQUIRY_LOGS_FAILURE'
export const GET_INQUIRY_LOG_DETAILS: string = 'GET_INQUIRY_LOG_DETAILS'
export const GET_INQUIRY_LOG_DETAILS_SUCCESS: string =
  'GET_INQUIRY_LOG_DETAILS_SUCCESS'
export const GET_INQUIRY_LOG_DETAILS_FAILURE: string =
  'GET_INQUIRY_LOG_DETAILS_FAILURE'
export const POST_INQUIRY_QUESTION: string = 'POST_INQUIRY_QUESTION'
export const DONE_POST_INQUIRY_QUESTION: string = 'DONE_POST_INQUIRY_QUESTION'
export const FAILURE_POST_INQUIRY_QUESTION: string =
  'FAILURE_POST_INQUIRY_QUESTION'
export const CONFIRM_INQUIRY_QUESTION: string = 'CONFIRM_INQUIRY_QUESTION'
export const PUT_INQUIRY: string = 'PUT_INQUIRY'
export const DONE_PUT_INQUIRY: string = 'DONE_PUT_INQUIRY'
export const FAILURE_PUT_INQUIRY: string = 'FAILURE_PUT_INQUIRY'



// WEBPACK FOOTER //
// ./src/constants/inquiry.constant.ts